import React from "react";
import { withRouter } from "react-router-dom";

class Signout extends React.Component {
  componentDidMount() {
    localStorage.clear();
    this.props.history.push("/");
  }
  render() {
    return null;
  }
}

export default withRouter(Signout);



// WEBPACK FOOTER //
// ./src/components/screens/Signout/Signout.jsx